import Image from '@/components/Image';
import NormalButton from '../Button/normal';
import ReactDOM from "react-dom";
import { X } from 'lucide-react';

interface PengiModalProps {
  visible: boolean;
  children: React.ReactNode;
  buttonTitle?: string;
  showPengiLogo?: boolean;
  showFooterButton?: boolean;
  width?: string;
  onClick?: () => void;
  transparentPanel?: boolean;
}

const PengiModal = ({
  visible,
  children,
  buttonTitle,
  showPengiLogo = true,
  showFooterButton = true,
  width = '',
  onClick,
  transparentPanel = false,
}: PengiModalProps) => {

  const handleClose = () => {
    onClick?.();
  }

  if (!visible) return null;

  return ReactDOM.createPortal(
    <div
      className="fixed inset-0"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 1000 }}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="fixed left-1/2 top-1/2 z-[1001] w-full max-w-[calc(100vw-1rem)] -translate-x-1/2 -translate-y-1/2 px-2 sm:max-w-[calc(100vw-2rem)] sm:px-0">
        <div
          className={`relative mx-auto w-[300px] md:w-[400px] animate-fade-in ${
            transparentPanel
              ? ""
              : "bg-white px-8 pt-8 pb-4 rounded-lg shadow-lg"
          }`}
          style={{ width: width, maxWidth: '100%' }}
          onClick={(e) => e.stopPropagation()}
        >
          {showPengiLogo && (
            <div className="absolute -top-[29px] left-1/2 flex h-[61px] w-[61px] -translate-x-1/2 items-center justify-center rounded-full bg-white">
              <Image src='/assets/landing-logo.png' alt='penguin' width={49} height={49} />
            </div>
          )}
          {onClick && (
            <button
              type="button"
              onClick={handleClose}
              className="absolute right-3 top-3 flex h-8 w-8 items-center justify-center rounded-full text-[#9CA3AF] hover:bg-[#F3F4F6] hover:text-[#374151] transition-colors"
              aria-label="Close"
            >
              <X className="h-4 w-4" />
            </button>
          )}
          <div className="flex flex-col gap-4 w-full justify-center items-center">
            {children}
            {showFooterButton && (
              <NormalButton onClick={handleClose}>
                {buttonTitle || 'Close'}
              </NormalButton>
            )}
          </div>
        </div>
      </div>
    </div>,
    document.body
  )
} 

export default PengiModal;
